"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BasketOfferTypes", {
  enumerable: true,
  get: function () {
    return _BasketOffer.BasketOfferTypes;
  }
});
exports.BasketUpdatedEvent = void 0;
Object.defineProperty(exports, "LastAddedItemMethod", {
  enumerable: true,
  get: function () {
    return _loyaltyDialogResult.Results;
  }
});
exports.Name = void 0;
Object.defineProperty(exports, "ShoppingNotificationType", {
  enumerable: true,
  get: function () {
    return _ShoppingNotification.ShoppingNotificationType;
  }
});
exports.Test = void 0;
var _loyaltyDialogResult = require("@ori-events/loyalty-dialog-result");
var _BasketOffer = require("./BasketOffer");
var _ShoppingNotification = require("./ShoppingNotification");
const Test = exports.Test = 'TEST';
const Name = exports.Name = 'basket-updated';
const BasketUpdatedEvent = exports.BasketUpdatedEvent = Name;
//# sourceMappingURL=index.js.map